<template>
  <page-layout
    :style="{ background: '#F9FBFF' }"
    :icon-config="{ url: '/', isBack: true, backText: '返回课题中心' }"
    v-loading="!isInited"
    :element-loading-text="taskLoading ? '课题正在加载中，课题首次加载需要多一点时间...' : ''"
    :title="courseTitle"
    content-max-width="1440px"
  >
    <div slot="custom-title" class="course-title-content">
      <el-tooltip effect="dark" placement="bottom">
        <div slot="content" :style="{ maxWidth: '300px' }">{{ courseTitle }}</div>
        <div class="title-text single-ellipsis">{{ courseTitle }}</div>
      </el-tooltip>
      <template v-if="isExpire">
        <div class="expire-timeout">课题已过期</div>
        <el-button
          type="primary"
          size="mini"
          :style="{ marginLeft: '20px' }"
          v-if="courseDetail._source.versionLevel === 1 && courseDetail._source.userId === $store.getters.userInfo.id"
          @click="renewHandle(courseDetail)"
        >
          <span>立即续费</span>
        </el-button>
      </template>
      <i class="iconfont iconbianji course-edit-icon" @click="titleEditor.showFunc(courseDetail)" v-else></i>
    </div>
    <div class="course-operation">
      <span class="course-condition-title">课题数据筛选条件</span>
      <div :class="[isPut ? '' : 'is-put', 'course-condition']">
        <!-- <div class="course-condition-content">
          <filter-tips
            v-if="courseDetail"
            :courseId="courseDetail._id"
            isNowrap
            byCourse
            :instrumentType="courseDetail ? courseDetail._source.instrumentType : ''"
            :showCloseBtn="!handleDisabled && !isExpire"
            :courseConditionArr="courseConditionArr"
            :courseFilterArr="courseFilterArr"
            :courseSortInfo="courseSortInfo"
            @delFilter="params => delFieldFilterHandle(params.index)"
            @delSort="delSortHandle()"
          />
        </div> -->
        <searchInfo
          :list="courseConditionArr"
          :instrumentType="courseDetail ? courseDetail._source.instrumentType : ''"
        />
      </div>
      <div class="case-search-put"></div>
      <div class="put-text" @click="isPut = !isPut">{{ isPut ? '收起' : '展开' }}</div>
    </div>

    <course-invite slot="custom-btn" v-if="courseDetail" :courseDetail="courseDetail" />

    <div class="databoard-usage" v-loading="loading">
      <div class="course-step-tip grid-item no-border">
        <div class="step-tip-content">
          <div class="step-tip-title">第一步：数据清洗</div>
          <div class="step-tip-desc">添加与课题相关的标签，并完成标注，以确保数据准确。</div>
          <div class="step-tip-tool-content">
            <el-button
              class="step-tool-btn"
              :disabled="handleDisabled || isExpire"
              type="primary"
              @click="goDataCleanHandle"
            >
              <i class="iconfont iconshuju btn-icon"></i>
              <span class="btn-text">数据清洗</span>
            </el-button>
          </div>
        </div>
        <div class="step-tip-content">
          <div class="step-tip-title">第二步：创建统计图表</div>
          <div class="step-tip-desc">确保数据标签准确后，创建并配置数据可视化统计图表。</div>
          <div class="step-tip-tool-content">
            <el-button
              class="step-tool-btn"
              :disabled="handleDisabled || isExpire"
              type="primary"
              @click="newPointDialog = true"
            >
              <i class="el-icon-plus btn-icon"></i>
              <span class="btn-text">创建统计图表</span>
            </el-button>
          </div>
        </div>
        <div class="step-tip-content">
          <div class="step-tip-title">第三步：下载课题报告</div>
          <div class="step-tip-desc">生成报告的内容和图表分析说明可复制，直接应用到文章。</div>
          <div class="step-tip-tool-content">
            <el-tooltip
              effect="light"
              placement="top"
              :disabled="!courseDetail || courseDetail._source.instrumentType === '裁判文书'"
              content="暂只支持以裁判文书为研究的课题下载课题报告。"
            >
              <span>
                <el-button
                  class="step-tool-btn gray-btn"
                  :disabled="
                    handleDisabled ||
                      (courseSource && courseSource.chart.length < 1) ||
                      courseDetail._source.instrumentType !== '裁判文书'
                  "
                  :loading="downReportLoading"
                  @click="downCourseReport"
                >
                  <i class="iconfont iconxiazai btn-icon" v-if="!downReportLoading"></i>
                  <span class="btn-text">下载课题报告</span>
                </el-button>
              </span>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="course-total-tip">
        <div class="grid-item no-border">
          <div class="instance-item">
            <div class="instance-header">
              <div class="title-text single-ellipsis">
                <span>课题案件总数</span>
              </div>
            </div>
            <div class="instance-box">
              <component :is="'numChart'" ref="caseTotalChart" byDashboard />
            </div>
          </div>
        </div>
        <div class="grid-item no-border" v-if="courseLockTipInfo.show">
          <div class="size-tip-content">
            <div class="size-tip-title">
              <img :src="lockImg" alt="" class="size-lock-icon" />
              <span>课题研究数量说明</span>
            </div>
            <div class="size-tip-text" v-if="courseLockTipInfo.isFree">
              <span>初始化数据为</span>
              <span v-if="courseDetail._source.course_size > courseDetail._source.totalCount">
                <span> {{ courseDetail._source.totalCount.toLocaleString() }} </span>
              </span>
              <span v-else> {{ courseDetail._source.course_size.toLocaleString() }} </span>
              <span>份文书。</span>
            </div>
            <template v-else>
              <div class="size-tip-text" v-if="courseDetail._source.course_size >= courseDetail._source.totalCount">
                <span>初始化数据为</span>
                <span> {{ courseDetail._source.totalCount.toLocaleString() }} </span>
                <span>份文书。</span>
              </div>
              <div class="size-tip-text" v-else>
                <span>符合筛选条件共</span>
                <span> {{ courseDetail._source.totalCount.toLocaleString() }} </span>
                <span>份文书，初始化数据为</span>
                <span> {{ courseDetail._source.course_size.toLocaleString() }} </span>
                <span>份文书。</span>
              </div>
            </template>
          </div>
        </div>
      </div>
      <template v-if="courseSource && courseSource.chart.length > 0">
        <draggable
          v-model="courseSource.chart"
          :disabled="isExpire"
          class="chart-ul"
          handle=".instance-header"
          @sort="sortChartHandle"
        >
          <div
            v-for="(instanceItem, instanceIndex) in courseSource.chart"
            :key="instanceItem.index_id"
            class="chart-li grid-item"
            :class="instanceItem.size === 'middle' ? 'middle-item' : 'large-item'"
            v-loading="refreshLoading"
          >
            <div class="instance-item">
              <div class="instance-header">
                <div class="title-text single-ellipsis">
                  <span>{{ instanceItem.title }}</span>
                </div>
                <div class="tool-content">
                  <el-tooltip
                    effect="dark"
                    :content="instanceItem.size === 'middle' ? '切换大尺寸' : '切换小尺寸'"
                    placement="top"
                    v-if="!isExpire"
                  >
                    <i
                      class="iconfont icon-btn"
                      :class="instanceItem.size === 'middle' ? 'icontubiaofangda' : 'icontubiaosuoxiao'"
                      @click.stop="handleCommand('checkSize', instanceIndex)"
                    ></i>
                  </el-tooltip>
                  <template v-if="!handleDisabled">
                    <el-tooltip effect="dark" content="引用图表元数据" placement="top">
                      <i class="iconfont iconyinyong icon-btn" @click.stop="shareDataHandle(instanceIndex)"></i>
                    </el-tooltip>
                    <template v-if="!isExpire">
                      <el-tooltip effect="dark" content="编辑研究点" placement="top">
                        <i class="iconfont iconbianji icon-btn" @click.stop="handleCommand('edit', instanceIndex)"></i>
                      </el-tooltip>
                      <el-tooltip effect="dark" content="复制研究点" placement="top">
                        <i class="iconfont iconfuzhi icon-btn" @click.stop="handleCommand('copy', instanceIndex)"></i>
                      </el-tooltip>
                      <el-tooltip effect="dark" content="删除研究点" placement="top">
                        <i class="iconfont iconshanchu icon-btn" @click.stop="handleCommand('del', instanceIndex)"></i>
                      </el-tooltip>
                    </template>
                  </template>
                </div>
              </div>
              <div class="instance-box" @click="handleCommand('edit', instanceIndex)">
                <component
                  :is="instanceItem.type"
                  :rows="instanceItem.rows"
                  :statistics="instanceItem.statistics"
                  :ref="`${instanceItem.type}_${instanceIndex}`"
                  byDashboard
                />
              </div>
            </div>
          </div>
        </draggable>
      </template>
      <div class="footer-content" :class="courseSource && courseSource.chart.length > 0 ? 'have-chart' : ''">
        <div class="date-info">
          <template v-if="courseDetail && courseDetail._source.create_time">
            <span class="create-info"
              >课题创建时间：{{ courseDetail._source.create_time | dateFilter('YYYY-MM-DD HH:mm') }}</span
            >
            <span class="update-info" v-if="courseDetail._source.updated_time"
              >课题修改时间：{{ courseDetail._source.updated_time | dateFilter('YYYY-MM-DD HH:mm') }}</span
            >
            <span class="update-info" v-if="expirationTime"
              >课题到期时间：{{ expirationTime | dateFilter('YYYY-MM-DD HH:mm') }}</span
            >
          </template>
        </div>
        <div class="footer-tools">
          <el-button type="primary" v-if="!handleDisabled" @click="shareDataHandle()">
            <i class="iconfont iconyinyong down-btn-icon"></i>
            <span>引用课题元数据</span>
          </el-button>
        </div>
      </div>
    </div>

    <el-dialog
      v-if="newPointDialog"
      :visible="newPointDialog"
      width="900px"
      title="创建统计图表"
      @close="newPointDialog = false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <research-creater :course-detail="courseDetail" @success="createSuccessHandle" />
    </el-dialog>

    <course-title-editor
      v-if="titleEditor.show"
      :show.sync="titleEditor.show"
      title="修改课题名称"
      :defaultTitleVal="titleEditor.value"
      :loading="titleEditor.loading"
      @confirm="val => updCourseTitleHandle(val)"
    />

    <data-share-modal
      v-if="shareDataModal.shareDataShow"
      :show.sync="shareDataModal.shareDataShow"
      :courseDetail="courseDetail"
      :researchModel="courseSource.chart[shareDataModal.researchIndex]"
    />

    <course-renew-dialog
      v-if="renewModal.show"
      :show.sync="renewModal.show"
      :detail="renewModal.detail"
      @success="renewSuccessHandle"
    />

    <copyModal
      v-if="copyModal.show"
      :show.sync="copyModal.show"
      :courseDetail="courseDetail"
      :researchModel="copyModal.chartItem"
      @success="copySuccessHandle"
    />
  </page-layout>
</template>

<script>
import pieChart from '@/components/chartComponents/pieChart';
import pieChart2 from '@/components/chartComponents/pieChart2';
import barChart from '@/components/chartComponents/barChart';
import barXChart from '@/components/chartComponents/barXChart';
import lineChart from '@/components/chartComponents/lineChart';
import lineChart2 from '@/components/chartComponents/lineChart2';
import numChart from '@/components/chartComponents/numChart';
import tableChart from '@/components/chartComponents/tableChart';
import tableAnalysisChart from '@/components/chartComponents/tableAnalysisChart';
import researchCreater from './components/researchCreater';
import courseTitleEditor from '@/components/courseTitleEditor';
import dataShareModal from '@/components/dataShareModal';
import courseRenewDialog from '@/components/courseRenewDialog';
import courseInvite from '@/components/courseInvite/index';
import copyModal from './components/copyModal';

import draggable from 'vuedraggable';
import { checkChartInfo } from '@/lib/utils';
import { services } from '@/service';
import { debounce } from 'lodash';
import lockImg from '@/assets/img/lock.png';
import dayjs from 'dayjs';

import filterTips from '@/components/filterTips';
import searchInfo from '@/components/searchInfo';

export default {
  components: {
    pieChart,
    pieChart2,
    barChart,
    barXChart,
    lineChart,
    lineChart2,
    numChart,
    tableChart,
    tableAnalysisChart,
    draggable,
    researchCreater,
    filterTips,
    searchInfo,
    courseTitleEditor,
    dataShareModal,
    courseRenewDialog,
    courseInvite,
    copyModal
  },
  data() {
    this.taskDone = null;

    return {
      isPut: false,
      lockImg,
      isInited: false,
      taskLoading: false,
      courseDetail: null,
      newPointDialog: false,
      loading: false,
      copyModal: {
        show: false,
        chartItem: null,
        init: function(item) {
          this.chartItem = item;
          this.show = true;
        }
      },
      titleEditor: {
        show: false,
        loading: false,
        value: '',
        showFunc: function(item) {
          this.loading = false;
          this.value = item._source.title;
          this.show = true;
        }
      },
      refreshLoading: false,
      downReportLoading: false,
      shareDataModal: {
        shareDataShow: false,
        researchIndex: -1
      },
      renewModal: {
        show: false,
        detail: null
      }
    };
  },
  computed: {
    courseLockTipInfo() {
      const courseDetail = this.courseDetail;
      if (this.handleDisabled || this.isExpire || !courseDetail) {
        return { show: false };
      }
      if (courseDetail._source.versionLevel === 0) {
        return { show: true, isFree: true };
      }
      return { show: true, isFree: false };
    },
    handleDisabled() {
      if (!this.courseDetail) {
        return true;
      }
      if (this.courseDetail._source.type === '示例课题' && !this.$store.getters.isAdmin) {
        return true;
      }
      if (this.courseDetail._source.limit === 'read') {
        return true;
      }
      return false;
    },
    courseTitle() {
      const courseDetail = this.courseDetail;
      if (!courseDetail || !courseDetail._source) {
        return '';
      }
      return courseDetail._source.title || '';
    },
    courseSource() {
      if (!this.courseDetail) {
        return null;
      }
      return this.courseDetail._source || null;
    },
    filterArr() {
      if (!this.courseDetail) {
        return [];
      }
      return (this.courseDetail._source.condition && JSON.parse(this.courseDetail._source.condition)) || [];
    },
    courseConditionArr() {
      return JSON.parse((this.courseDetail && this.courseDetail._source.condition) || '[]');
    },
    courseFilterArr() {
      return JSON.parse((this.courseDetail && this.courseDetail._source.conditionTemp) || '[]');
    },
    courseSortInfo() {
      return (this.courseDetail && this.courseDetail._source.sortInfo) || null;
    },
    expirationTime() {
      if (!this.courseDetail) {
        return '';
      }
      return this.courseDetail._source.expirationTime;
    },
    isExpire() {
      if (!this.expirationTime) {
        return false;
      }
      return dayjs().isAfter(dayjs(this.expirationTime));
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.refreshLoading) {
      this.$message.warning('图表刷新中，请稍等...');
      next(false);
      return;
    }
    if (this.taskDone) {
      this.taskDone();
    }
    next();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeChartHandle);
  },
  created() {
    this.resizeChartHandle = debounce(this.resizeChartHandle.bind(this), 300);
    window.addEventListener('resize', this.resizeChartHandle);
  },
  async mounted() {
    try {
      const id = this.$route.query.courseware_id;
      this.courseDetail = await services.courseware.getCoursewareDetail(id, {
        changeTaskStatus: (status, taskDone = null) => {
          this.taskLoading = status;
          this.taskDone = taskDone;
        }
      });
      this.$refs.caseTotalChart &&
        this.$refs.caseTotalChart.refresh(
          {
            originData: {
              rowsData: [{ 总案件数: this.courseDetail._source.currentCaseCount }],
              columnsData: ['总案件数']
            },
            rows: [],
            columns: [],
            statistics: [],
            relationFilterVal: 'case',
            relationFilterName: '以案件为单位'
          },
          { haveOriginData: true }
        );
      await this.$nextTick();
      this.refreshInstance();
      this.isInited = true;
    } catch (err) {
      this.$error(err);
    }
  },
  methods: {
    renewHandle(item) {
      this.renewModal = {
        show: true,
        detail: item
      };
    },
    async renewSuccessHandle() {
      try {
        this.isInited = false;
        this.courseDetail = await services.courseware.getCoursewareDetail(this.renewModal.detail._id);
      } catch (err) {
        this.$error(err);
      } finally {
        this.isInited = true;
      }
    },
    shareDataHandle(researchIndex = -1) {
      this.shareDataModal = {
        shareDataShow: true,
        researchIndex
      };
    },
    createSuccessHandle({ newChart }) {
      this.newPointDialog = false;
      this.routeToResearchDetail(newChart.index_id);
    },
    routeToResearchDetail(chartIndexId) {
      this.$router.push({
        path: '/case-research',
        query: {
          courseware_id: this.$route.query.courseware_id,
          index_id: chartIndexId
        }
      });
    },
    handleCommand(command, instanceIndex) {
      const chartIndexId = this.courseSource.chart[instanceIndex].index_id;
      if (command === 'checkSize') {
        const chartItem = this.courseSource.chart[instanceIndex];
        const size = chartItem.size === 'middle' ? 'large' : 'middle';
        this.courseSource.chart.splice(instanceIndex, 1, {
          ...chartItem,
          size
        });
        this.sortChartHandle();
        this.$nextTick(() => {
          this.resizeChartHandle();
        });
      }
      if (command === 'edit') {
        if (!this.isExpire) {
          this.routeToResearchDetail(chartIndexId);
        }
      }
      if (command === 'del') {
        this.delResearchHandle(instanceIndex, chartIndexId);
      }
      if (command === 'copy') {
        this.copyModal.init(this.courseDetail._source.chart[instanceIndex]);
      }
    },
    async sortChartHandle() {
      try {
        await services.courseware.saveCourseware(this.courseDetail._id, {
          ...this.courseSource,
          chart: this.courseSource.chart
        });
      } catch (err) {
        this.$error(err);
      }
    },
    copySuccessHandle(courseSource) {
      this.courseDetail._source = courseSource;
      this.$nextTick(() => {
        this.refreshInstance();
      });
    },
    async downCourseReport() {
      try {
        this.downReportLoading = true;
        const result = await services.courseware.downCourseReport(this.$route.query.courseware_id);
        services.logger.handleLog({ operateName: '下载报告', apiUrl: '/nlp/download/report' });
        const reader = new FileReader();
        reader.readAsDataURL(result);
        reader.onload = e => {
          const a = document.createElement('a');
          a.download = `${this.courseDetail._source.title}研究报告.docx`;
          a.href = e.target.result;
          a.click();
          this.$message.success('课题报告下载成功');
        };
      } catch (err) {
        this.$error(err);
      } finally {
        this.downReportLoading = false;
      }
    },
    async clearResearchHandle() {
      await this.$confirm('是否删除所有研究点', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      });
      try {
        this.courseDetail._source.chart = [];
        this.sortChartHandle();
      } catch (err) {
        this.$error(err);
      }
    },
    async delResearchHandle(instanceIndex, chartIndexId) {
      await this.$confirm(`是否删除该研究点?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      });
      try {
        const chartIndex = this.courseDetail._source.chart.findIndex(chartItem => chartItem.index_id === chartIndexId);
        this.courseDetail._source.chart.splice(chartIndex, 1);

        this.sortChartHandle();

        // 等待grid-lyaout重排后再保存研究点位置
        await this.$nextTick();
        this.courseSource.chart.forEach((instanceItem, instanceIndex) => {
          const chartComponentEl = this.$refs[`${instanceItem.type}_${instanceIndex}`][0];
          chartComponentEl.refresh &&
            chartComponentEl.refresh(
              checkChartInfo({
                colors: instanceItem.colors,
                chartConfig: instanceItem.chartConfig,
                rows: instanceItem.rows,
                columns: instanceItem.columns,
                statistics: instanceItem.statistics,
                researchCondition: instanceItem.conditionTemp,
                courseCondition: this.courseDetail._source.conditionTemp,
                courseId: this.courseDetail._id,
                originData: JSON.parse(instanceItem.dataSet || '{}'),
                sortStatistic: JSON.parse(instanceItem.sortStatistic || '{}'),
                relationFilterVal: instanceItem.relationFilterVal,
                relationFilterName: instanceItem.relationFilterName
              }),
              { haveOriginData: true }
            );
        });
      } catch (err) {
        this.$error(err);
      }
    },
    resizeChartHandle() {
      const charts = (this.courseSource && this.courseSource.chart) || [];
      charts.forEach((instanceItem, instanceIndex) => {
        const chartComponentEl = this.$refs[`${instanceItem.type}_${instanceIndex}`][0];
        chartComponentEl.resize && chartComponentEl.resize();
      });
    },
    async refreshInstance() {
      if (!this.courseSource) {
        return;
      }
      try {
        this.refreshLoading = true;
        const charts = (this.courseSource && this.courseSource.chart) || [];

        let needRefresh = !!this.courseSource.refresh;

        if (!needRefresh) {
          needRefresh = charts.every(instanceItem => {
            return Object.keys(JSON.parse(instanceItem.dataSet || '{}')).length < 1;
          });
        }

        const options = { haveOriginData: !needRefresh };
        const infoArr = charts.map((instanceItem, instanceIndex) => {
          const chartEl = this.$refs[`${instanceItem.type}_${instanceIndex}`];
          const chartComponentEl = chartEl && chartEl[0];
          const componData = checkChartInfo({
            colors: instanceItem.colors,
            chartConfig: instanceItem.chartConfig,
            rows: instanceItem.rows,
            columns: instanceItem.columns,
            statistics: instanceItem.statistics,
            researchCondition: instanceItem.conditionTemp,
            courseCondition: this.courseDetail._source.conditionTemp,
            courseId: this.courseDetail._id,
            sortStatistic: JSON.parse(instanceItem.sortStatistic || '{}'),
            relationFilterVal: instanceItem.relationFilterVal,
            relationFilterName: instanceItem.relationFilterName
          });
          if (options.haveOriginData) {
            componData.originData = JSON.parse(instanceItem.dataSet || '{}');
          }
          if (!chartComponentEl) {
            throw new Error('页面已跳转');
          }
          if (options.haveOriginData) {
            chartComponentEl.refresh(componData, options);
          } else {
            const dataSource = this.mergeDataSourceHandle(
              this.courseDetail._source.conditionTemp,
              instanceItem.conditionTemp
            );
            return {
              dataSource,
              componData,
              req_type: chartComponentEl.chartType === 'tableAnalysisChart' ? 'super' : 'basic'
            };
          }
        });

        if (!options.haveOriginData) {
          const dataSetArr = await services.research.batchGetDimensionData(infoArr, this.courseDetail._id);
          dataSetArr.forEach(async (dataSetItem, dataSetIndex) => {
            const instanceItem = charts[dataSetIndex];
            const chartEl = this.$refs[`${instanceItem.type}_${dataSetIndex}`];
            const chartComponentEl = chartEl && chartEl[0];
            const { dataSet } = await chartComponentEl.refresh(
              { ...infoArr[dataSetIndex].componData, originData: dataSetItem },
              { haveOriginData: true }
            );
            const dataSetStr = JSON.stringify(dataSet || {});
            instanceItem.dataSet = dataSetStr;
          });
          this.courseDetail._source.chart = charts;
          this.courseDetail._source.refresh = false;
          await services.courseware.saveCourseware(this.courseDetail._id, { ...this.courseSource });
        }
      } catch (err) {
        if (err.message === '页面已跳转') {
          return;
        }
        this.$error(err || '处理异常');
      } finally {
        this.refreshLoading = false;
      }
    },
    mergeDataSourceHandle(courseCondition, researchCondition) {
      return { query: [...JSON.parse(courseCondition || '[]'), ...JSON.parse(researchCondition || '[]')] };
    },
    goDataCleanHandle() {
      this.$router.push({
        path: '/data-cleaner',
        query: {
          courseware_id: this.courseDetail._id
        }
      });
    },
    delFieldFilterHandle(index) {
      const filterArr = [...this.courseFilterArr];
      filterArr.splice(index, 1);
      const newCourseSource = { ...this.courseDetail._source, conditionTemp: JSON.stringify(filterArr) };
      this.courseDetail._source = { ...newCourseSource, refresh: true };
    },
    async delSortHandle() {
      try {
        const newCourseSource = {
          ...this.courseDetail._source,
          sortInfo: ''
        };
        await services.courseware.saveCourseware(this.courseDetail._id, newCourseSource);
        this.courseDetail._source = newCourseSource;
      } catch (err) {
        this.$error(err);
      }
    },
    async updCourseTitleHandle(title) {
      try {
        this.titleEditor.loading = true;
        const item = this.courseDetail;
        await services.courseware.saveCourseware(item._id, { ...item._source, title });
        this.courseDetail._source.title = title;
        this.titleEditor.show = false;
        this.$message.success(`课题标题修改成功`);
      } catch (err) {
        this.$error(err);
      } finally {
        this.titleEditor.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$fontColor: #474f60;

.databoard-usage {
  margin: 10px 0 50px;

  .footer-content {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
    padding: 0 20px;

    &.have-chart {
      margin-top: 0;
    }

    .footer-tools {
      .down-btn-icon {
        font-size: 14px;
        margin-right: 4px;
      }
    }

    .date-info {
      font-size: 14px;
      color: rgba(#77839e, 0.7);

      .update-info {
        position: relative;
        margin-left: 10px;
        padding-left: 10px;

        &::before {
          content: ' ';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          height: 80%;
          width: 1px;
          background-color: #9599a5;
        }
      }
    }
  }

  .course-step-tip {
    margin: 20px 20px 0;
    display: flex;

    .step-tip-content {
      box-sizing: border-box;
      flex: 1;
      width: 0;
      padding: 18px 0 18px 20px;
      background-color: #fff;

      .step-tip-title {
        color: #2c3443;
        font-size: 16px;
        line-height: 24px;
      }

      .step-tip-desc {
        color: #77839e;
        font-size: 14px;
        line-height: 20px;
        margin-top: 8px;
        font-weight: 300;
      }

      .step-tip-tool-content {
        margin-top: 16px;

        .step-tool-btn {
          font-size: 14px;
          width: 140px;

          .btn-text {
            margin-left: 0;
          }

          .btn-icon {
            font-size: 14px;
            font-weight: bold;
            margin-right: 5px;
          }

          &.gray-btn {
            color: #77839e;
          }
        }
      }
    }
  }

  .course-total-tip {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 20px 20px 0;
    .grid-item {
      width: calc(50% - 10px);
      height: 160px;
      background-color: #fff;

      .instance-item {
        .instance-box {
          cursor: default !important;
          padding-bottom: 20px;
        }
        &:hover {
          .instance-header {
            background-color: #fff;
          }
        }
      }

      .size-tip-content {
        box-sizing: border-box;
        height: 100%;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        padding: 45px 20px;

        .size-tip-title {
          font-size: 16px;
          color: #1991fb;
          width: 100%;
          .size-lock-icon {
            position: relative;
            top: 1px;
            height: 16px;
            margin-right: 4px;
          }
        }

        .size-tip-text {
          font-size: 14px;
          color: rgba(#2c3443, 0.8);
          line-height: 22px;
          margin-top: 10px;
        }
      }
    }
  }

  .chart-ul {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 20px 20px 0;
  }

  .grid-item {
    box-sizing: border-box;
    box-shadow: 0 2px 4px 2px rgba(#8196b4, 0.16);
    overflow: auto;
    border-radius: 4px;
    border: 1px solid #fff;

    $instanceHeaderHeight: 50px;

    .instance-item {
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      background-color: #fff;

      .instance-header {
        box-sizing: border-box;
        display: flex;
        align-items: center;
        padding: 17px 20px;
        color: #212731;
        height: $instanceHeaderHeight;
        cursor: move;

        .title-text {
          flex: 1;
          width: 0;
        }

        .tool-content {
          opacity: 0;
          padding-left: 10px;

          .icon-btn {
            font-size: 14px;
            color: rgba(0, 0, 0, 0.5);
            padding: 5px;
            margin-right: 5px;
            cursor: pointer;

            &:last-child {
              margin-right: 0;
            }
          }
        }
      }

      .instance-box {
        box-sizing: border-box;
        position: relative;
        width: calc(100% - 20px);
        height: calc(100% - #{$instanceHeaderHeight} - 20px);
        margin: 10px;
        cursor: pointer !important;

        .pre-loading {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 10;
        }
      }
    }
    &:hover {
      border-color: #1991fb;

      .instance-header {
        background-color: #f8fafd;
      }

      .tool-content {
        opacity: 1 !important;
      }
    }

    &.no-border {
      &:hover {
        border-color: #fff;
      }
    }

    &.chart-li {
      width: calc(50% - 10px);
      margin-bottom: 20px;
      &.large-item {
        width: 100%;

        .instance-item {
          padding-bottom: calc(30% + #{$instanceHeaderHeight});
        }
      }

      .instance-item {
        position: relative;
        padding-bottom: calc(50% + #{$instanceHeaderHeight});

        .instance-header {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
        }

        .instance-box {
          box-sizing: border-box;
          position: absolute;
          top: #{$instanceHeaderHeight};
          left: 0;
          width: calc(100% - 20px);
          height: calc(100% - #{$instanceHeaderHeight} - 20px);
          overflow: auto;
        }
      }
    }
  }
}

.course-title-content {
  display: flex;
  align-items: center;

  .expire-timeout {
    color: #fff;
    padding: 5px 10px;
    border-radius: 10px 0;
    background-color: #ffbd53;
    margin-left: 5px;
    font-size: 12px;
  }

  .course-edit-icon {
    margin-left: 2px;
    padding: 2px 3px;
    cursor: pointer;
    opacity: 0;
  }

  .title-text {
    display: inline-block;
    max-width: calc(100% - 130px);
  }

  &:hover {
    .course-edit-icon {
      opacity: 1;
    }
  }
}
.course-operation {
  box-sizing: border-box;
  // padding: 0 calc((100% - 1440px) / 2);
  line-height: 30px;
  position: relative;
  background-color: #fff;
  margin: 2px 20px 0;
  box-shadow: 0 2px 4px 2px rgb(129 150 180 / 16%);
  // border-bottom: 1px solid #ebeef5;

  .course-condition-title {
    display: inline-block;
    margin: 10px 20px 0;
    color: #2c3443;
    font-size: 14px;
  }
  .course-condition {
    position: relative;
    box-sizing: border-box;
    // width: 100%;
    display: flex;
    background-color: #fff;
    height: auto;
    &.is-put {
      height: 64px;
      overflow: hidden;
    }

    .course-condition-content {
      flex: 1;
      white-space: nowrap;
      overflow: auto;

      &::-webkit-scrollbar {
        display: none;
      }
    }
  }

  .case-search-put {
    position: absolute;
    bottom: 0px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.11) 0%, #ffffff 100%);
    border-radius: 1px;
    filter: blur(0.5px);
    width: 100%;
    left: 0%;
    z-index: 10;
    height: 30px;
  }
  .put-text {
    cursor: pointer;
    color: #2c7ddc;
    position: absolute;
    bottom: 0px;
    font-size: 14px;
    width: 100%;
    z-index: 20;
    text-align: center;
  }
}
</style>

<style lang="scss">
.newPoint-panel {
  &-item {
    margin-bottom: 20px;
    p {
      margin-bottom: 20px;
    }
  }
}
</style>
